
export const editProfileInfo ={

    fullName:"",
    email:"",
    profilePicture:"",
    contactNumber:"",
  }